import { transformations, unwrap as buildResponseTransformation, } from '../common';
const buildRequestTransformation = () => transformations.JS_SINGLE_ARG_UNCHANGED;
export { buildRequestTransformation, buildResponseTransformation };
//# sourceMappingURL=list.js.map